import { NudgeType, useNudgeStore } from "@/store";
import { useCurrentConversationId } from "./conversation";
import { useAuthState } from "./useAuthState";

export const useSignupNudge = (): {
  nudgeType: NudgeType | undefined;
} => {
  const { conversationsWithNudgeShown } = useNudgeStore();
  const { isSignedIn, isLoading: isAuthLoading } = useAuthState();
  const conversationId = useCurrentConversationId();

  const nudge = conversationId
    ? conversationsWithNudgeShown[conversationId]
    : undefined;

  return !isSignedIn && !isAuthLoading
    ? {
        nudgeType: nudge?.type,
      }
    : {
        nudgeType: undefined,
      };
};
